import { useQuery } from '@tanstack/react-query'
import { listAgents } from '../../../data/statsAssistant'
import { statsAssistantKeys } from './statsAssistant.keys'

export const useAgents = () =>
  useQuery({
    queryKey: statsAssistantKeys.agents,
    queryFn: async () => {
      const { data, ok } = await listAgents()
      if (!data || !ok) {
        throw new Error('Impossible de charger les profils statistiques')
      }
      return data
    },
    staleTime: 5 * 60_000,
  })
